import React from "react";
import PropTypes from "prop-types";
import { FlatButton } from "material-ui";
import { gql, graphql } from "react-apollo";

class Notes extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    fieldName: PropTypes.string,
    value: PropTypes.string,
    mutate: PropTypes.func.isRequired,
    onChange: PropTypes.func
  };

  static defaultProps = {
    fieldName: "Notes",
    value: "",
    onChange: () => {}
  };

  constructor(props) {
    super(props);

    if (typeof window !== "undefined") {
      this.ReactQuill = require("react-quill"); // eslint-disable-line global-require
    }

    this.state = {
      value: this.props.value,
      editing: false,
      isDirty: false
    };
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.handleUnload);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleUnload);
  }

  handleUnload = e => {
    const { isDirty } = this.state;
    const event = e || window.event;

    if (!isDirty) {
      return undefined;
    }

    const message =
      "You have unsaved changes in your notes, leaving without " +
      "saving will cause them to be lost.";

    event.preventDefault();
    event.returnValue = message;
    return message;
  };

  handleChange = value => {
    this.setState({ value, isDirty: true });
    this.props.onChange(true);
  };

  edit = () => {
    this.setState({ editing: true });
  };

  cancel = () => {
    this.setState({ editing: false, value: this.props.value, isDirty: false });
    this.props.onChange(false);
  };

  submit = () => {
    const { id, fieldName, mutate } = this.props;
    const { value } = this.state;

    mutate({
      variables: {
        id,
        field: fieldName,
        note: value
      }
    });

    this.setState({ editing: false, isDirty: false });
    this.props.onChange(false);
  };

  content = () => {
    const ReactQuill = this.ReactQuill;
    const { editing, value } = this.state;

    if (editing && typeof window !== "undefined" && ReactQuill) {
      return (
        <div>
          <ReactQuill value={value} onChange={this.handleChange} />
        </div>
      );
    }
    return (
      // eslint-disable-next-line react/no-danger
      <div className="ql-editor" dangerouslySetInnerHTML={{ __html: value }} />
    );
  };

  buttons = () => {
    const { editing } = this.state;

    if (editing) {
      return (
        <div>
          <FlatButton label="Cancel" onClick={this.cancel} />
          <FlatButton label="Submit" onClick={this.submit} />
        </div>
      );
    }

    return <FlatButton label="Edit" onClick={this.edit} />;
  };

  render() {
    const content = this.content();
    const buttons = this.buttons();

    return (
      <div>
        {content}
        {buttons}
      </div>
    );
  }
}

const submitNotes = gql`
  mutation submitNotes($id: String!, $field: String!, $note: String!) {
    setNoteField(id: $id, field: $field, note: $note) {
      field
      note
    }
  }
`;

const NotesWithData = graphql(submitNotes)(Notes);

export default NotesWithData;



// WEBPACK FOOTER //
// /src/components/NotesComponent.js